import Vue from 'vue'
import Router from 'vue-router'

import Home from "@/views/Home"
import Tutorial from "@/views/Tutorial"
import Geolocation from "@/views/Geolocation"
import QRCode from "@/views/QRCode"
import Place from "@/views/Place"
import LastPanel from "@/views/LastPanel"
import Video from "@/views/Video"
import Debug from "@/views/Debug"

Vue.use(Router)

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'Hello',
    //   component: Hello
    // },
    {
      path: '/debug',
      name: "Debug",
      component: Debug
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/tutorial',
      name: 'Tutorial',
      component: Tutorial
    },
    {
      path: '/geolocation/:place?',
      name: 'Geolocation',
      component: Geolocation,
      props: true
    },
    {
      path: '/video/:video',
      name: "Video",
      component: Video,
      props: true
    },
    {
      path: '/qrcode',
      name: 'QRCode',
      component: QRCode
    },
    {
      path: '/place',
      alias: ['/place1', '/place2', '/place3', '/place4', '/place5'],
      name: 'Place',
      component: Place
    },
    {
      path: '/lastpanel',
      name: 'LastPanel',
      component: LastPanel
    },
  ]
})





// WEBPACK FOOTER //
// ./src/router/index.js